import { createFileRoute } from "@tanstack/react-router";
import { ChatRoute } from "src/containers/ChatsRoute";

export const Route = createFileRoute("/_layout/chats")({
    component: Chats,
});

function Chats() {
    return <ChatRoute />;
}
